export const categoryModel = {
  categoryName: "",
  description: "",
  displayOrder: 999,
  parentCategoryID: "",
};
